import React from "react"
import { Link, navigate } from "gatsby"
import CommunityImg from "../CommunityImg/CommunityImg"
import { default as CompostableBadge } from "../../../images/eco-sustainability-Compostable-badge.svg"
import { default as RecycledBadge } from "../../../images/eco-sustainability-Recycled-badge.svg"
import { default as ReusableBadge } from "../../../images/eco-sustainability-reusable-badge.svg"
import * as styles from "./SustainabilityHeader.module.scss"
import "./SustainabilityHeader.scss"

const SustainabilityHeader = ({ productType }) => {
  const ProductInfo = {
    Compostable: {
      img: CompostableBadge,
      color: "#697F6C",
    },
    Recycle: {
      img: RecycledBadge,
      color: "#3A3A6E",
    },
    Reusable: {
      img: ReusableBadge,
      color: "#DE5F72",
    },
  }

  return (
    <div className="sustainability-header">
      <div className="sustainability-badge">
        <CommunityImg
          src={ProductInfo[productType].img}
          alt="Compostible badge"
        />
      </div>
      <h2 className="heading" style={{ color: ProductInfo[productType].color }}>
        Our Circular Material Frameworks
      </h2>
      <p className="header-subheading">
        All products on the noissue platform belong to one of the below circular
        frameworks:
      </p>
      <div
        className={`button-container ${productType} ${styles.buttonContainer}`}
      >
        <button
          className={`btn ${productType === "Compostable" && "selected"}`}
          onClick={() => navigate("/compostable")}
        >
          Compostable
        </button>
        <button
          className={`btn ${productType === "Recycle" && "selected"}`}
          onClick={() => navigate("/recycle")}
        >
          Recycled
        </button>
        <button
          className={`btn ${productType === "Reusable" && "selected"}`}
          onClick={() => navigate("/reusable")}
        >
          Reusable
        </button>
      </div>
    </div>
  )
}

export default SustainabilityHeader
